import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import TestsCard from './TestsCard';

export default class Tests extends Component {
	render() {
		return (
			<div>

				<Link to={`/dodaj`} className="card mb-0 btn schoolSelection-card">
					<div className="card-body text-center">
						<i className="fas fa-file-invoice"></i> Dodaj test
					</div>
				</Link>

				{this.props.heading && (
					<React.Fragment>


						<h1 className="h1 text-center d-block mt-3 mb-3">{this.props.heading}
							<span className="text-small d-block mb-1">{` (${this.props.tests.length})`}</span>
						</h1>
						{/*
						<div className="card mb-1 btn schoolSelection-card bg-white p-0">
							<div className="card-body text-center">
								<em>Janez Novak</em><br />
								<strong className="text-primary mb-0">Inštrukcije FIZ, MAT</strong>
							</div>
						</div>
	
						<div className="card mb-1 btn schoolSelection-card p-0 bg-white">
							<div className="card-body text-center">
								<strong className="text-primary mb-0">Inštrukcije FIZ, MAT</strong>
							</div>
						</div>*/}
					</React.Fragment>
				)}





				{this.props.tests && this.props.tests.map(test => {
					return <TestsCard test={test} key={test.id} />
				})}

				{this.props.loadingState === 'Loading' && (
					<div className="pt-3 text-center">
						<h5><i className="fas fa-spinner"></i></h5>
					</div>
				)}
			</div>
		)
	}
}
